import createValueModule from "@/redux/create-value-module";

import { $MessagesModuleName, TMessagesState } from "./messages.types";

const { constants: _constants, actions } = createValueModule<TMessagesState>(
    $MessagesModuleName,
    []
);

export const clear = actions.clear;
export const set = actions.set;
export const update = actions.update;

export const constants = _constants;
